module.exports = __webpack_public_path__ + "img/9.0855a3f4.jpg";